"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const intl_utils_1 = require("@formatjs/intl-utils");
const date_fns_1 = require("date-fns");
exports.getRelativeDateTime = (date) => {
    return intl_utils_1.selectUnit(date_fns_1.getTime(date), Date.now());
};
//# sourceMappingURL=get-relative-date-time.js.map